var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42644_5301)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0183 24C18.6558 24 24.0365 18.6274 24.0365 12C24.0365 5.37258 18.6558 0 12.0183 0C5.38076 0 -1.14441e-05 5.37258 -1.14441e-05 12C-1.14441e-05 18.6274 5.38076 24 12.0183 24Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0183 23.6353C18.5549 23.6353 23.8539 18.3443 23.8539 11.8176C23.8539 5.29093 18.5549 0 12.0183 0C5.48164 0 0.182644 5.29093 0.182644 11.8176C0.182644 18.3443 5.48164 23.6353 12.0183 23.6353Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42644_5301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 16,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6895 10.4325H12.2009V13.5328H16.5114C16.1096 15.5024 14.4292 16.6331 12.2009 16.6331C9.57078 16.6331 7.45206 14.5176 7.45206 11.8915C7.45206 9.26536 9.57078 7.14986 12.2009 7.14986C13.3333 7.14986 14.3562 7.55109 15.1598 8.20762L17.4977 5.87327C16.0731 4.63314 14.2466 3.86719 12.2009 3.86719C7.7443 3.86719 4.16439 7.44166 4.16439 11.8915C4.16439 16.3414 7.7443 19.9158 12.2009 19.9158C16.2192 19.9158 19.8722 16.9979 19.8722 11.8915C19.8722 11.4173 19.7991 10.9067 19.6895 10.4325Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42644_5301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4338 16.6337V7.15039L9.64384 11.892L3.4338 16.6337Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_42644_5301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 16,
    height: 17
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6895 10.4325H12.2009V13.5328H16.5114C16.1096 15.5024 14.4292 16.6331 12.2009 16.6331C9.57078 16.6331 7.45206 14.5176 7.45206 11.8915C7.45206 9.26536 9.57078 7.14986 12.2009 7.14986C13.3333 7.14986 14.3562 7.55109 15.1598 8.20762L17.4977 5.87327C16.0731 4.63314 14.2466 3.86719 12.2009 3.86719C7.7443 3.86719 4.16439 7.44166 4.16439 11.8915C4.16439 16.3414 7.7443 19.9158 12.2009 19.9158C16.2192 19.9158 19.8722 16.9979 19.8722 11.8915C19.8722 11.4173 19.7991 10.9067 19.6895 10.4325Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_42644_5301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4338 7.15083L9.64384 11.8925L12.2009 9.66756L20.968 8.24505V3.13867H3.4338V7.15083Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_42644_5301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 16,
    height: 17
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6895 10.4325H12.2009V13.5328H16.5114C16.1096 15.5024 14.4292 16.6331 12.2009 16.6331C9.57078 16.6331 7.45206 14.5176 7.45206 11.8915C7.45206 9.26536 9.57078 7.14986 12.2009 7.14986C13.3333 7.14986 14.3562 7.55109 15.1598 8.20762L17.4977 5.87327C16.0731 4.63314 14.2466 3.86719 12.2009 3.86719C7.7443 3.86719 4.16439 7.44166 4.16439 11.8915C4.16439 16.3414 7.7443 19.9158 12.2009 19.9158C16.2192 19.9158 19.8722 16.9979 19.8722 11.8915C19.8722 11.4173 19.7991 10.9067 19.6895 10.4325Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_42644_5301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.4338 16.6341L14.3927 8.24505L17.2785 8.6098L20.968 3.13867V20.6463H3.4338V16.6341Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_42644_5301",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 16,
    height: 17
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6895 10.4325H12.2009V13.5328H16.5114C16.1096 15.5024 14.4292 16.6331 12.2009 16.6331C9.57078 16.6331 7.45206 14.5176 7.45206 11.8915C7.45206 9.26536 9.57078 7.14986 12.2009 7.14986C13.3333 7.14986 14.3562 7.55109 15.1598 8.20762L17.4977 5.87327C16.0731 4.63314 14.2466 3.86719 12.2009 3.86719C7.7443 3.86719 4.16439 7.44166 4.16439 11.8915C4.16439 16.3414 7.7443 19.9158 12.2009 19.9158C16.2192 19.9158 19.8722 16.9979 19.8722 11.8915C19.8722 11.4173 19.7991 10.9067 19.6895 10.4325Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_42644_5301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.968 20.6458L9.64384 11.892L8.18266 10.7978L20.968 7.15039V20.6458Z",
    fill: "#4285F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42644_5301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.f020bb7c2b938015da1f564060af2b55.svg";
export { ForwardRef as ReactComponent };